module.exports = __webpack_public_path__ + "media/images/expert__selectedArrow--dark-663147b70b295b4e577243ed7e1ba3e4.png";